import React, { Component } from 'react';
import { TouchableOpacity } from 'react-native';

import Text from '../../react-component/textComponent';

import styles from './styles';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Creators as toastActions } from '../../store/ducks/toast';

class ToastItem extends Component {
    state = {
        count: 0
    };
    componentDidMount() {
        const {
            autoHide = true,
            theme,
            autoHideTime = theme === 'error' ? 5000 : 2000
        } = this.props;

        if (autoHide) {
            setTimeout(this.props.onHandler, autoHideTime);
        }
    }

    componentWillReceiveProps() {
        if (this.state.count < 2) {
            let { count } = this.state;
            count++;
            this.setState({ count });
        } else {
            this.props.removeAllToast();
            this.setState({ count: 0 });
        }
    }
    render() {
        const { text, theme } = this.props;
        const themeBg = theme ? styles[theme] : null;
        const themeText = theme ? styles[`${theme}Text`] : null;

        return (
            <TouchableOpacity
                onPress={() => this.props.onHandler()}
                activeOpacity={1}
                style={[styles.content, themeBg]}
            >
                <Text style={[themeText, styles.label]}>{text}</Text>
            </TouchableOpacity>
        );
    }
}

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(toastActions, dispatch);

const mapStateToProps = (state) => ({
    toasts: state.toast
});

export default connect(mapStateToProps, mapDispatchToProps)(ToastItem);
